export default {
  header: 'Flyt',
};
